const defaultStyles = {
  fontFamily: 'Tahoma, Verdana, Segoe, sans-serif',
  fontSize: '14px',
  lineHeight: '120%'
}

const defaultStylesInline = 'font-family: Tahoma, Verdana, Segoe, sans-serif;font-size: 14px;line-height: 120%'

export const joditConfig = {
  autofocus: true,
  enter: 'div',
  toolbar: false,
  defaultMode: 1,
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  disablePlugins: 'search, source, placeholder, stat, size, tablekeyboardnavigation,' +
    'tooltip, addnewline, enter',
  style: defaultStyles
}

export default joditConfig

export {defaultStylesInline}



// WEBPACK FOOTER //
// ./src/constants/joditConfig.js